'use client';
import type { ImageType } from '@eliadmin/core/src/api/api-types';
import { CategoryCard } from '@eliadmin/core/src/components/categories/category-card';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import React from 'react';
import { SubpageHeader } from '../ui/subpage-header';

export type Category = {
  data?: Category[];
  childs: Category[];
  name: string;
  description: string;
  short_description: string;
  slug: string;
  icon?: string;
  image?: ImageType;
};

type CategoriesPageNewProps = {
  categories: Category[];
};

export const CategoriesPageNew = ({ categories }: CategoriesPageNewProps) => {
  const { t } = useTranslations();

  return (
    <>
      <SubpageHeader
        breadcrumbs={[{ label: t('text176'), href: ROUTES.CATEGORIES() }]}
        title={t('text176')}
      />
      <section className={cn('custom-section', 'py-8 sm:py-10 lg:py-12')}>
        <div
          className={cn(
            'custom-container',
            'grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6 lg:grid-cols-3',
          )}
        >
          {categories.map(category => (
            <CategoryCard category={category as any} key={category.slug} />
          ))}
        </div>
      </section>
    </>
  );
};
